import { render, staticRenderFns } from "./JISSReport.vue?vue&type=template&id=4850a65c&scoped=true&"
import script from "./JISSReport.vue?vue&type=script&lang=js&"
export * from "./JISSReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850a65c",
  null
  
)

export default component.exports